/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsflagdobchanged3Inputs */

const en_signupsflagdobchanged3 = /** @type {(inputs: Signupsflagdobchanged3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birth date changed`)
};

const de_signupsflagdobchanged3 = /** @type {(inputs: Signupsflagdobchanged3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsdatum geändert`)
};

/**
* | output |
* | --- |
* | "Birth date changed" |
*
* @param {Signupsflagdobchanged3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsflagdobchanged3 = /** @type {((inputs?: Signupsflagdobchanged3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsflagdobchanged3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsflagdobchanged3(inputs)
	return de_signupsflagdobchanged3(inputs)
});
export { signupsflagdobchanged3 as "signupsFlagDobChanged" }